<div class="checkout-page">
  <main class="checkout-container">

    <!-- CABEÇALHO -->
    <div class="checkout-heading" *ngIf="!resultadoPix && !resultadoCartao">
      <span class="eyebrow">ASSINATURA CUIDAZAP</span>
      <h1>Seu cuidado começa aqui</h1>
      <p>Preencha os dados abaixo para concluir sua assinatura.</p>
    </div>

    <!-- CARREGAMENTO DOS PLANOS -->
    <div *ngIf="carregandoPlanos && !resultadoPix && !resultadoCartao" class="loading-panel">
      <span class="spinner"></span>
      Carregando planos...
    </div>

    <!-- FORMULÁRIO DO CHECKOUT -->
    <form
      *ngIf="!carregandoPlanos && !resultadoPix && !resultadoCartao"
      #checkoutForm="ngForm"
      (ngSubmit)="finalizarCompra(checkoutForm)"
      novalidate
    >
      <div class="checkout-layout">

        <div class="checkout-main">

          <!-- 01 - PLANO -->
          <section class="checkout-card">
            <div class="section-heading">
              <span class="section-number">01</span>
              <div>
                <h2>Escolha seu plano</h2>
                <p>Selecione a duração da sua assinatura Premium.</p>
              </div>
            </div>

            <div *ngIf="planos.length === 0" class="inline-error">
              Não foi possível carregar os planos. Verifique a conexão com o servidor.
              <button type="button" class="text-button" (click)="carregarPlanos()">
                Tentar novamente
              </button>
            </div>

            <div class="plans-grid" *ngIf="planos.length > 0">
              <button
                type="button"
                *ngFor="let plano of planos"
                class="plan-option"
                [class.selected]="planoSelecionado?.codigo === plano.codigo"
                (click)="selecionarPlano(plano)"
              >
                <span class="plan-radio">
                  <span *ngIf="planoSelecionado?.codigo === plano.codigo"></span>
                </span>

                <span class="plan-content">
                  <strong>{{ nomePlano(plano) }}</strong>
                  <span *ngIf="plano.codigo === 'PREMIUM_MENSAL'">
                    Cobrança mensal • Renovação automática
                  </span>

                  <span *ngIf="plano.codigo !== 'PREMIUM_MENSAL'">
                    {{ plano.intervaloMeses }} meses de acesso
                  </span>
                  <b>{{ formatarMoeda(plano.valor) }}</b>
                </span>

                <span *ngIf="plano.intervaloMeses === 12" class="plan-tag">
                  Melhor custo-benefício
                </span>
              </button>
            </div>

            <div *ngIf="planoSelecionado" class="plan-benefits">
              <h3>Premium: tudo para cuidar melhor</h3>
              <ul>
                <li>Conversa e companhia 24 horas por dia</li>
                <li>Lembretes de consultas e medicamentos</li>
                <li>Pedido de ajuda</li>
                <li>Verificador de notícias falsas</li>
                <li>Validador de boletos</li>
                <li>Apoio para atividades físicas</li>
                <li>Busca de UPA e UBS</li>
              </ul>
            </div>
          </section>

          <!-- 02 - COMPRADOR -->
          <section class="checkout-card">
            <div class="section-heading">
              <span class="section-number">02</span>
              <div>
                <h2>Quem está contratando?</h2>
                <p>Informe os dados da pessoa responsável pela assinatura.</p>
              </div>
            </div>

            <div class="form-grid">
              <div class="field full-width">
                <label for="nomeComprador">Nome completo *</label>
                <input
                  id="nomeComprador"
                  name="nomeComprador"
                  type="text"
                  [(ngModel)]="comprador.nome"
                  autocomplete="name"
                  placeholder="Seu nome completo"
                  required
                  minlength="3"
                />
              </div>

              <div class="field">
                <label for="telefoneComprador">Telefone *</label>
                <input
                  id="telefoneComprador"
                  name="telefoneComprador"
                  type="tel"
                  [(ngModel)]="comprador.telefone"
                  (ngModelChange)="comprador.telefone = aplicarMascaraTelefone($event)"
                  autocomplete="tel"
                  placeholder="(11) 99999-9999"
                  required
                  minlength="14"
                />
              </div>

              <div class="field">
                <label for="emailComprador">E-mail *</label>
                <input
                  id="emailComprador"
                  name="emailComprador"
                  type="email"
                  [(ngModel)]="comprador.email"
                  autocomplete="email"
                  placeholder="voce@exemplo.com"
                  required
                />
              </div>

              <div class="field">
                <label for="cpfComprador">CPF *</label>
                <input
                  id="cpfComprador"
                  name="cpfComprador"
                  type="text"
                  [(ngModel)]="comprador.cpf"
                  (ngModelChange)="comprador.cpf = aplicarMascaraCpf($event)"
                  autocomplete="off"
                  placeholder="000.000.000-00"
                  maxlength="14"
                  required
                />
              </div>

              <div class="field">
                <label for="vinculoUsuario">Seu vínculo com o usuário *</label>
                <input
                  id="vinculoUsuario"
                  name="vinculoUsuario"
                  type="text"
                  [(ngModel)]="comprador.vinculoUsuario"
                  placeholder="Ex.: filha, filho, amigo"
                  required
                />
              </div>
            </div>

            <div class="emergency-choice">
              <label class="checkbox-line">
                <input
                  type="checkbox"
                  name="compradorEhEmergencia"
                  [(ngModel)]="compradorEhEmergencia"
                />
                <span>Eu também serei o contato de emergência.</span>
              </label>
            </div>

            <div *ngIf="!compradorEhEmergencia" class="subsection">
              <h3>Contato de emergência</h3>
              <p>Informe alguém que possa ser contatado quando necessário.</p>

              <div class="form-grid">
                <div class="field full-width">
                  <label for="nomeEmergencia">Nome completo *</label>
                  <input
                    id="nomeEmergencia"
                    name="nomeEmergencia"
                    [(ngModel)]="emergencia.nome"
                    placeholder="Nome do contato"
                    required
                  />
                </div>

                <div class="field">
                  <label for="telefoneEmergencia">Telefone *</label>
                  <input
                    id="telefoneEmergencia"
                    name="telefoneEmergencia"
                    type="tel"
                    [(ngModel)]="emergencia.telefone"
                    (ngModelChange)="emergencia.telefone = aplicarMascaraTelefone($event)"
                    placeholder="(11) 99999-9999"
                    required
                    minlength="14"
                  />
                </div>

                <div class="field">
                  <label for="emailEmergencia">E-mail</label>
                  <input
                    id="emailEmergencia"
                    name="emailEmergencia"
                    type="email"
                    [(ngModel)]="emergencia.email"
                    placeholder="contato@exemplo.com"
                  />
                </div>
              </div>
            </div>
          </section>

          <!-- 03 - USUÁRIO -->
          <section class="checkout-card">
            <div class="section-heading">
              <span class="section-number">03</span>
              <div>
                <h2>Quem vai usar o CuidaZap?</h2>
                <p>Esses dados serão utilizados para configurar o atendimento.</p>
              </div>
            </div>

            <div class="form-grid">
              <div class="field full-width">
                <label for="nomeUsuario">Nome completo *</label>
                <input
                  id="nomeUsuario"
                  name="nomeUsuario"
                  [(ngModel)]="usuario.nome"
                  autocomplete="off"
                  placeholder="Nome de quem utilizará o CuidaZap"
                  required
                  minlength="3"
                />
              </div>

              <div class="field">
                <label for="telefoneUsuario">Telefone/WhatsApp *</label>
                <input
                  id="telefoneUsuario"
                  name="telefoneUsuario"
                  type="tel"
                  [(ngModel)]="usuario.telefone"
                  (ngModelChange)="usuario.telefone = aplicarMascaraTelefone($event)"
                  placeholder="(11) 99999-9999"
                  required
                  minlength="14"
                />
              </div>

              <div class="field">
                <label for="emailUsuario">E-mail</label>
                <input
                  id="emailUsuario"
                  name="emailUsuario"
                  type="email"
                  [(ngModel)]="usuario.email"
                  placeholder="usuario@exemplo.com"
                />
              </div>

              <div class="field">
                <label for="dataNascimento">Data de nascimento *</label>
                <input
                  id="dataNascimento"
                  name="dataNascimento"
                  type="date"
                  [(ngModel)]="usuario.dataNascimento"
                  [max]="dataMaximaNascimento"
                  required
                />
              </div>
            </div>

            <div class="mobility-question">
              <p>
                A pessoa apresenta alguma limitação física, histórico de fratura
                ou dificuldade de mobilidade?
              </p>

              <div class="radio-row">
                <label class="radio-line">
                  <input
                    type="radio"
                    name="possuiLimitacaoFisica"
                    [value]="true"
                    [(ngModel)]="usuario.possuiLimitacaoFisica"
                  />
                  Sim
                </label>

                <label class="radio-line">
                  <input
                    type="radio"
                    name="possuiLimitacaoFisica"
                    [value]="false"
                    [(ngModel)]="usuario.possuiLimitacaoFisica"
                  />
                  Não
                </label>
              </div>

              <div class="field" *ngIf="usuario.possuiLimitacaoFisica">
                <label for="informacaoMobilidade">Conte um pouco mais</label>
                <textarea
                  id="informacaoMobilidade"
                  name="informacaoMobilidade"
                  [(ngModel)]="usuario.informacaoMobilidade"
                  rows="3"
                  placeholder="Descreva as informações relevantes para o atendimento"
                ></textarea>
              </div>
            </div>
          </section>

          <!-- 04 - ENDEREÇO -->
          <section class="checkout-card">
            <div class="section-heading">
              <span class="section-number">04</span>
              <div>
                <h2>Endereço do responsável</h2>
                <p>Informe o endereço para os dados de cobrança.</p>
              </div>
            </div>

            <div class="form-grid">
              <div class="field">
                <label for="cep">CEP *</label>
                <input
                  id="cep"
                  name="cep"
                  [(ngModel)]="endereco.cep"
                  (ngModelChange)="endereco.cep = aplicarMascaraCep($event)"
                  (blur)="buscarCep()"
                  placeholder="00000-000"
                  maxlength="9"
                  required
                  minlength="9"
                />
              </div>

              <div class="field field-grow">
                <label for="logradouro">Rua/avenida *</label>
                <input
                  id="logradouro"
                  name="logradouro"
                  [(ngModel)]="endereco.logradouro"
                  placeholder="Nome da rua"
                  required
                />
              </div>

              <div class="field">
                <label for="numeroEndereco">Número *</label>
                <input
                  id="numeroEndereco"
                  name="numeroEndereco"
                  [(ngModel)]="endereco.numero"
                  placeholder="Número"
                  required
                />
              </div>

              <div class="field">
                <label for="bairro">Bairro *</label>
                <input
                  id="bairro"
                  name="bairro"
                  [(ngModel)]="endereco.bairro"
                  placeholder="Bairro"
                  required
                />
              </div>

              <div class="field">
                <label for="complemento">Complemento</label>
                <input
                  id="complemento"
                  name="complemento"
                  [(ngModel)]="endereco.complemento"
                  placeholder="Apto., casa etc."
                />
              </div>

              <div class="field field-grow">
                <label for="cidade">Cidade *</label>
                <input
                  id="cidade"
                  name="cidade"
                  [(ngModel)]="endereco.cidade"
                  placeholder="Cidade"
                  required
                />
              </div>

              <div class="field">
                <label for="uf">Estado *</label>
                <select id="uf" name="uf" [(ngModel)]="endereco.uf" required>
                  <option value="">Selecione</option>
                  <option *ngFor="let estado of estados" [value]="estado">
                    {{ estado }}
                  </option>
                </select>
              </div>
            </div>

            <p class="field-hint" *ngIf="buscandoCep">
              Consultando CEP...
            </p>
          </section>

          <!-- 05 - PAGAMENTO -->
          <section class="checkout-card">
            <div class="section-heading">
              <span class="section-number">05</span>
              <div>
                <h2>Forma de pagamento</h2>
                <p>Escolha como deseja pagar sua assinatura.</p>
              </div>
            </div>

            <div class="payment-methods">
              <button
                *ngIf="planoSelecionado?.codigo !== 'PREMIUM_MENSAL'"
                type="button"
                class="payment-option"
                [class.selected]="formaPagamento === 'PIX'"
                (click)="selecionarPagamento('PIX')"
              >
                <span class="payment-symbol pix-symbol">◇</span>

                <span>
                  <strong>Pix</strong>
                  <small>QR Code ou copia e cola</small>
                </span>

                              <span class="plan-radio">
                  <span *ngIf="formaPagamento === 'PIX'"></span>
                </span>
              </button>

              <button
                type="button"
                class="payment-option"
                [class.selected]="formaPagamento === 'CARTAO'"
                (click)="selecionarPagamento('CARTAO')"
              >
                <span class="payment-symbol">▤</span>
                <span>
                  <strong>Cartão de crédito</strong>
                  <small>
                    {{ planoSelecionado?.codigo === 'PREMIUM_MENSAL'
                    ? 'Cobrança automática mensal'
                    : 'À vista ou parcelado em até 6 vezes' }}
                  </small>
                </span>
                <span class="plan-radio">
                  <span *ngIf="formaPagamento === 'CARTAO'"></span>
                </span>
              </button>
            </div>

            <!-- DADOS DO CARTÃO -->
            <div *ngIf="formaPagamento === 'CARTAO'" class="card-fields">
              <div class="form-grid">
                <div class="field full-width">
                  <label for="numeroCartao">Número do cartão *</label>
                  <input
                    id="numeroCartao"
                    name="numeroCartao"
                    type="text"
                    [(ngModel)]="cartao.numero"
                    (ngModelChange)="cartao.numero = aplicarMascaraCartao($event)"
                    autocomplete="cc-number"
                    inputmode="numeric"
                    placeholder="0000 0000 0000 0000"
                    maxlength="19"
                    required
                  />
                </div>

                <div class="field full-width">
                  <label for="titularCartao">Nome impresso no cartão *</label>
                  <input
                    id="titularCartao"
                    name="titularCartao"
                    [(ngModel)]="cartao.titular"
                    autocomplete="cc-name"
                    placeholder="Nome como aparece no cartão"
                    required
                  />
                </div>

                <div class="field">
                  <label for="validadeCartao">Validade (MM/AAAA) *</label>
                  <input
                    id="validadeCartao"
                    name="validadeCartao"
                    [(ngModel)]="cartao.validade"
                    (ngModelChange)="cartao.validade = aplicarMascaraValidade($event)"
                    autocomplete="cc-exp"
                    inputmode="numeric"
                    placeholder="MM/AAAA"
                    maxlength="7"
                    required
                  />
                </div>

                <div class="field">
                  <label for="cvvCartao">CVV *</label>
                  <input
                    id="cvvCartao"
                    name="cvvCartao"
                    type="password"
                    [(ngModel)]="cartao.cvv"
                    autocomplete="cc-csc"
                    inputmode="numeric"
                    placeholder="3 ou 4 dígitos"
                    maxlength="4"
                    required
                  />
                </div>

                <div class="field">
                  <label for="cpfTitular">CPF do titular *</label>
                  <input
                    id="cpfTitular"
                    name="cpfTitular"
                    [(ngModel)]="cartao.cpfCnpjTitular"
                    (ngModelChange)="cartao.cpfCnpjTitular = aplicarMascaraCpf($event)"
                    placeholder="000.000.000-00"
                    maxlength="14"
                    required
                  />
                </div>


                <div
                  class="field"
                  *ngIf="planoSelecionado?.codigo !== 'PREMIUM_MENSAL'"
                >
                  <label for="parcelas">Parcelamento *</label>

                  <select
                    id="parcelas"
                    name="parcelas"
                    [(ngModel)]="quantidadeParcelas"
                    required
                  >
                    <option
                      *ngFor="let parcela of opcoesParcelamento"
                      [ngValue]="parcela"
                    >
                      {{ parcela }}x de
                      {{ formatarMoeda(calcularValorParcela(parcela)) }}
                    </option>
                  </select>

                  <small class="field-hint">
                    Parcelamento disponível em até
                    {{ maximoParcelas }} vezes.
                  </small>
                </div>

                <div
                  class="field full-width"
                  *ngIf="planoSelecionado?.codigo === 'PREMIUM_MENSAL'"
                >
                  <p class="field-hint">
                    Seu cartão será cobrado automaticamente todos os meses.
                    Você poderá cancelar a renovação automática quando desejar.
                  </p>
                </div>

              </div>
            </div>

            <!-- INFORMAÇÃO PIX -->
            <div *ngIf="formaPagamento === 'PIX'" class="pix-info">
              <span class="pix-info-icon">◇</span>
              <div>
                <strong>Pagamento instantâneo</strong>
                <p>
                  Depois de criar o pedido, você poderá escanear o QR Code
                  ou copiar o código Pix para realizar o pagamento.
                </p>
              </div>
            </div>
          </section>

          <!-- CONSENTIMENTOS -->
          <section class="checkout-card consent-card">
            <label class="checkbox-line" *ngIf="planoSelecionado?.codigo === 'PREMIUM_MENSAL'">
              <input
                type="checkbox"
                name="recorrenciaAceita"
                [(ngModel)]="recorrenciaAceita"
                required
              />
              <span>
                Autorizo a cobrança automática mensal no cartão pelo valor informado
                no resumo. Entendo que posso cancelar as próximas renovações a qualquer momento.
              </span>
            </label>
            <label class="checkbox-line">
              <input
                type="checkbox"
                name="termosAceitos"
                [(ngModel)]="termosAceitos"
                required
              />
              <span>
                Li e aceito os
                <a
                  href="https://cuidazap.com/termos"
                  target="_blank"
                  rel="noopener noreferrer"
                >termos e condições</a>.
              </span>
            </label>

            <label class="checkbox-line">
              <input
                type="checkbox"
                name="privacidadeAceita"
                [(ngModel)]="privacidadeAceita"
                required
              />
              <span>
                Li e aceito a
                <a
                  href="https://cuidazap.com/privacidade"
                  target="_blank"
                  rel="noopener noreferrer"
                >política de privacidade</a>.
              </span>
            </label>
          </section>

          <!-- BOTÃO MOBILE -->
          <button
            class="submit-button mobile-submit"
            type="submit"
            [disabled]="processando || planos.length === 0"
          >
            <span *ngIf="!processando">
              Assinar plano <span aria-hidden="true">→</span>
            </span>

            <span *ngIf="processando" class="button-loading">
              <span class="spinner spinner-light"></span>
              Processando pagamento...
            </span>
          </button>
        </div>

        <!-- RESUMO DA ASSINATURA -->
        <aside class="checkout-sidebar">
          <div class="summary-card">
            <div class="summary-header">
              <span class="summary-kicker">RESUMO DA ASSINATURA</span>
              <h2>Seu plano</h2>
            </div>

            <div *ngIf="planoSelecionado" class="summary-plan">
              <div class="summary-plan-icon">✦</div>
              <div>
                <strong>CuidaZap Premium</strong>
                <p>{{ nomePlano(planoSelecionado) }}</p>
              </div>
            </div>

            <div *ngIf="planoSelecionado" class="summary-line">
              <span>Duração</span>
              <strong>
                {{
                  planoSelecionado.codigo === 'PREMIUM_MENSAL'
                    ? 'Mensal com renovação automática'
                    : planoSelecionado.intervaloMeses + ' meses'
                }}
              </strong>
            </div>

            <div class="summary-line">
              <span>Forma de pagamento</span>
              <strong>
                {{ formaPagamento === 'PIX' ? 'Pix' : 'Cartão de crédito' }}
              </strong>
            </div>

            <div class="summary-divider"></div>


            <div class="summary-line">
              <span>Valor do plano</span>
              <strong>
                {{ formatarMoeda(planoSelecionado?.valor) }}
              </strong>
            </div>


            <div
              class="summary-line"
              *ngIf="formaPagamento === 'CARTAO' && taxaEstimada > 0"
            >
              <span>Taxa de processamento</span>
              <strong>{{ formatarMoeda(taxaEstimada) }}</strong>
            </div>


            <div class="summary-divider"></div>

            <div class="summary-total">
              <span>{{ planoSelecionado?.codigo === 'PREMIUM_MENSAL' ? 'Valor da mensalidade' : 'Total estimado' }}</span>
              <strong>
                {{ formatarMoeda(valorTotalEstimado) }}
              </strong>
            </div>

            <div
              *ngIf="formaPagamento === 'CARTAO' && planoSelecionado?.codigo !== 'PREMIUM_MENSAL'"
              class="summary-line"
            >
              <span>Parcelamento</span>
              <strong>
                {{ quantidadeParcelas }}x de
                {{ formatarMoeda(calcularValorParcela(quantidadeParcelas)) }}
              </strong>
            </div>


            <p class="summary-note" *ngIf="planoSelecionado?.codigo === 'PREMIUM_MENSAL'">
              Cobrança automática no cartão a cada mês. Você pode cancelar a renovação
              quando desejar. O valor mostrado deve corresponder ao valor efetivamente
              configurado para cada cobrança no Asaas.
            </p>
            <p class="summary-note" *ngIf="planoSelecionado?.codigo !== 'PREMIUM_MENSAL'">
              O valor e as condições de pagamento são processados pelo backend
              e pelo Asaas.
            </p>

            <button
              class="submit-button desktop-submit"
              type="button"
              [disabled]="processando || planos.length === 0"
              (click)="enviarFormulario(checkoutForm)"
            >
              <span *ngIf="!processando">
                Assinar plano <span aria-hidden="true">→</span>
              </span>

              <span *ngIf="processando" class="button-loading">
                <span class="spinner spinner-light"></span>
                Processando...
              </span>
            </button>
          </div>
        </aside>
      </div>
    </form>

    <!-- RESULTADO DO PIX -->
    <section
      *ngIf="resultadoPix && !pagamentoConfirmado"
      class="payment-result pix-result"
    >

      <div class="result-icon">◇</div>

      <span class="eyebrow">PAGAMENTO VIA PIX</span>

      <h2>Escaneie o QR Code para pagar</h2>

      <p>
        Abra o aplicativo do seu banco e escaneie o QR Code abaixo.
        Se preferir, copie o código Pix para realizar o pagamento.
      </p>

      <!-- QR CODE -->
      <div class="pix-qr-container" *ngIf="imagemQrCode; else semQrCode">
        <img
          [src]="imagemQrCode"
          alt="QR Code Pix para pagamento"
          class="pix-qr-image"
        />
      </div>

      <ng-template #semQrCode>
        <p class="field-hint">
          O QR Code não está disponível no momento.
        </p>
      </ng-template>

      <!-- PIX COPIA E COLA -->
      <div
        class="pix-copia-cola"
        *ngIf="resultadoPix.copiaECola"
      >
        <label for="codigoPix">Pix copia e cola</label>

        <textarea
          id="codigoPix"
          [value]="resultadoPix.copiaECola"
          readonly
          rows="4"
        ></textarea>

        <button
          type="button"
          (click)="copiarPix()"
        >
          {{ pixCopiado ? 'Código copiado!' : 'Copiar código Pix' }}
        </button>
      </div>

      <!-- EXPIRAÇÃO -->
      <p *ngIf="resultadoPix.expiraEm" class="field-hint">
        Expiração:
        {{ resultadoPix.expiraEm | date:'dd/MM/yyyy HH:mm' }}
      </p>

      <!-- STATUS -->
      <div class="payment-status-panel">
        <span class="status-indicator"></span>

        <div>
          <strong>Status do pagamento</strong>

          <p>
            {{ traduzirStatusPagamento(resultadoPix.status) }}
          </p>

          <small>
            O pedido só será considerado pago após a confirmação do servidor.
          </small>
        </div>
      </div>

      <p class="field-hint">
        Após pagar, mantenha esta tela aberta enquanto a confirmação é processada.
      </p>

    </section>

    <!-- RESULTADO DO CARTÃO -->
    <section
      *ngIf="resultadoCartao && !pagamentoConfirmado"
      class="payment-result card-result"
    >
      <div class="result-icon">✓</div>
      <span class="eyebrow">PAGAMENTO COM CARTÃO</span>

      <h2>Estamos verificando seu pagamento</h2>

      <p>
        Sua solicitação foi enviada para processamento. A assinatura só será
        considerada paga quando o Asaas confirmar o pagamento.
      </p>

      <div class="payment-status-panel">
        <span class="status-indicator"></span>
        <div>
          <strong>Status do pagamento</strong>
          <p>{{ traduzirStatusPagamento(resultadoCartao.status) }}</p>
          <small>
            A aprovação pode depender da análise da operadora do cartão.
          </small>
        </div>
      </div>
    </section>

    <!-- PAGAMENTO CONFIRMADO -->
    <section
      *ngIf="pagamentoConfirmado"
      class="payment-result success-result"
      aria-live="polite"
    >
      <div class="success-result-icon">✓</div>

      <span class="eyebrow">BEM-VINDO AO CUIDAZAP</span>

      <h2>Pagamento confirmado. Obrigado pela confiança!</h2>

      <p class="success-user-name">
        {{ usuario.nome || 'Sua pessoa especial' }}
      </p>

      <p>
        A assinatura foi confirmada e o CuidaZap já está em ação para
        acompanhar e oferecer mais cuidado a
        <strong>{{ usuario.nome || 'você' }}</strong>.
      </p>

      <div class="success-message-panel">
        <span class="success-message-icon">✦</span>

        <div>
          <strong>Seu cuidado começa agora!</strong>

          <p>
            O cadastro foi realizado com sucesso. O CuidaZap está pronto
            para fazer parte da rotina de {{ usuario.nome || 'quem você ama' }},
            com companhia, lembretes e recursos de apoio no dia a dia.
          </p>
        </div>
      </div>

      <p class="success-footer">
        Obrigado por escolher o CuidaZap. Cuidar de quem importa faz toda a diferença.
      </p>
    </section>

  </main>
</div>
